import React from 'react';
import { arrayOf, any, objectOf, func, string, number, bool } from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Scrollchor } from 'react-scrollchor';
import get from 'lodash/get';
import { titleText, formatDate } from '../../../helpers/utils';
import { CLICK_KEY_HIGHLIGHT } from '../../../../store/actions';
import { DATE_FORMATS } from '../../../constants';
import './key-highlights.module.css';
import Icon from '@mdi/react';
import { mdiChevronRight } from '@mdi/js';
import { BQLink } from '../../atoms/bqlink';
import { contentClick } from '../../../helpers/datalayer-utils';

const KeyHighlights = ({
  cards,
  label = 'Key Highlights',
  limit = 5,
  lbhref = null,
  budgetHeading = false,
  darkMode = false,
  widget = false,
}) => {
  const keyhighlights =
    cards
      ?.filter((card) => get(card, ['metadata', 'attributes', 'key-event'], card))
      .map((card) => ({ title: titleText(card), card })) || [];
  return (
    <div
      styleName={`wrapper ${darkMode ? 'dark-mode' : widget ? 'auto-dark' : ''}`}
      className="key-highlights-wrapper"
    >
      <div styleName="heading-wrapper">
        {widget && <div styleName="margin-line left" />}
        <h2 styleName="heading">
          <img src="/images/ic_wifi_tethering_24px.svg" alt="Live Highlights" />
          {budgetHeading ? (
            <BQLink styleName="budget-heading" href={lbhref} target={widget ? '_blank' : '_self'}>
              Budget<span>Live</span> <Icon path={mdiChevronRight} size="30px" color="#d01e51" />
            </BQLink>
          ) : (
            <> {label} </>
          )}
        </h2>
        {widget && <div styleName="margin-line right" />}
      </div>
      <ul styleName="list">
        {keyhighlights.length !== 0
          ? keyhighlights
              .slice(0, limit)
              .map((highlight) => (
                <Keyhighlight
                  key={`highlight-${highlight?.card?.id}`}
                  highlight={highlight}
                  lburl={lbhref}
                  darkMode={darkMode}
                  widget={widget}
                />
              ))
          : Array.apply(null, Array(3)).map(() => (
              <div styleName="key-highlight-shimmer">
                <div styleName="shimmer-ctx">
                  <div styleName="first-row"></div>
                  <div styleName="second-row">
                    <div styleName="first-part"></div>
                    <div styleName="second-part"></div>
                  </div>
                </div>
              </div>
            ))}
      </ul>
    </div>
  );
};

const KeyHighlightBase = ({ highlight, lburl, onClick, index, darkMode, widget }) => {
  const onKeyItem = () => {
    window.open(
      widget
        ? `${lburl}#card-${highlight?.card?.id}`
        : `${window.location.origin}/${lburl}#card-${highlight?.card?.id}`,
      widget ? '_blank' : '_self',
    );
  };
  const dateTime = formatDate(highlight?.card['card-added-at'], DATE_FORMATS.HOUR_MINUTE);
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  return (
    <li
      id={highlight?.card?.id}
      styleName="key"
      onClick={() => {
        contentClick(userData, highlight, pageType);
      }}
    >
      <div styleName="time-wrapper">
        <time
          styleName={`${index === 0 ? 'recenttime' : 'time'}`}
          id={highlight?.card?.id}
          dateTime={dateTime}
        >
          {dateTime}
        </time>
        <span styleName={`${index === 0 ? 'first-watch' : 'watch'}`} />
      </div>
      {lburl ? (
        <a
          href={`${lburl}#card-${highlight?.card?.id}`}
          id={highlight?.card?.id}
          styleName="key-link"
          onClick={onKeyItem}
          target={widget ? '_blank' : '_self'}
        >
          <span id={highlight?.card?.id} styleName="text">
            {highlight?.title}
          </span>
        </a>
      ) : (
        <Scrollchor
          to={`#card-${highlight?.card?.id}`}
          styleName="key-link"
          animate={{ offset: -90 }}
        >
          <span id={highlight?.card?.id} styleName="text">
            {highlight?.title}
          </span>
        </Scrollchor>
      )}
    </li>
  );
};

KeyHighlights.propTypes = {
  cards: arrayOf(any).isRequired,
  label: string,
  limit: number,
  lbhref: string,
  index: number.isRequired,
  darkMode: bool,
};

KeyHighlightBase.propTypes = {
  highlight: objectOf(any).isRequired,
  onClick: func.isRequired,
  lburl: string,
  darkMode: bool,
};

function mapDispatchToProps(dispatch) {
  return {
    onClick: (e) => {
      e.preventDefault();
      e.stopPropagation();
      dispatch({
        type: CLICK_KEY_HIGHLIGHT,
        cardId: e.target.id,
      });
    },
  };
}

const Keyhighlight = connect((state) => ({}), mapDispatchToProps)(KeyHighlightBase);

export { KeyHighlights };
